import { render } from "./EmailNotifications.vue?vue&type=template&id=47c36ce0"
import script from "./EmailNotifications.vue?vue&type=script&lang=js"
export * from "./EmailNotifications.vue?vue&type=script&lang=js"
script.render = render

export default script